<template>
  <div style="white-space: nowrap; align-self: center">
    {{ parkingTime }} / {{ parkingCost.toFixed(2) }} {{ currency_short }}
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  props: [
    'priceRules',
    'activeParking'
  ],
  data() {
    return {
      currency_short: process.env.CURRENCY_SHORT,
      date_time_format: 'DD.MM.YYYY HH:mm',
      minutes_in_hour: 60,
      minutes_in_day: 24 * 60,
      parkingCost: 0,
      parkingTime: '00 min',
      startingPrice: 0
    }
  },
  created() {
    const startTime = moment.utc(this.activeParking[0].start_time)
    let minutesParked = moment().diff(startTime, 'minutes', false)
    this.parkingCost = this.activeParking[0].price || 0
    if (minutesParked > 0) {
      this.parkingTime = this.formatPeriod(minutesParked)
    }
  },
  methods: {
    formatPeriod(minutes, unit) {
      if (unit === 'month') {
        return `${minutes} ${this.$tc('pricingrules.month', minutes)}`;
      }
      let min = minutes;
      let days = Math.floor(min / this.minutes_in_day);
      min -= days * this.minutes_in_day;
      let hours = Math.floor(min / this.minutes_in_hour);
      min -= hours * this.minutes_in_hour;
      if (days === 1) {
        days = `${days} ${this.$tc('pricingrules.day', 1)} `;
      } else if (days > 1) {
        days = `${days} ${this.$tc('pricingrules.day', 2)} `;
      } else {
        days = '';
      }
      if (hours) {
        hours = `${hours} ${this.$t('pricingrules.hour')} `;
      } else {
        hours = '';
      }
      if (min) {
        min = `${min} ${this.$t('pricingrules.minute')} `;
      } else {
        min = '';
      }
      return (days + hours + min).trim();
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pricingrules/product/ParkingCostInfo.vue